import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Score} from "../domain/score";
import {ExtendedScore} from "../domain/extended-score";

@Injectable({
  providedIn: 'root'
})
export class ScoreService {

  private readonly SERVICE_URL = `/api/score`;

  constructor(private http: HttpClient) {
  }

  createScore(userName: string, score: string): Observable<Score> {
    const scoreObject: Score = {
      userName: userName,
      score: score
    };
    return this.http.post<Score>(this.SERVICE_URL, scoreObject);
  }

  getTop3Scores(): Observable<Score[]> {
    return this.http.get<Score[]>(this.SERVICE_URL);
  }

  getUserScoreWithRank(userName: string): Observable<ExtendedScore | null> {
    return this.http.get<ExtendedScore | null>(this.SERVICE_URL + '/' + encodeURIComponent(userName));
  }

  getAllScores(): Observable<Score[]> {
    return this.http.get<Score[]>(this.SERVICE_URL + '/all')
  }

  resetScores(): Observable<any> {
    return this.http.post<any>(this.SERVICE_URL + "/admin/reset", {});
  }

  deleteScore(userName: string): Observable<boolean> {
    return this.http.delete<boolean>(this.SERVICE_URL + '/admin/' + encodeURIComponent(userName))
  }
}
